import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'connect-delivery-customization-function',
  templateUrl: './connect-delivery-customization-function.component.html',
  styleUrls: ['./connect-delivery-customization-function.component.scss'],
  standalone: false,
})
export class ConnectDeliveryCustomizationFunctionComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() settings: CheckoutSettings;
  @Input() requirements: { updateRequired: boolean; updateAppUrl: string };

  constructor() {}

  ngOnInit(): void {}
}
